<template>
  <form
    class="form-entrar"
    @submit.prevent="enviar"
  >
    <div id="butom">
      <a @click="voltar()">Voltar</a>
    </div>

    <!-- FLUXO 1: Sem token → pede o email -->
    <template v-if="!token">
      <h3>Esqueci Minha Senha</h3>
      <h4>Digite seu email para a recuperação da sua conta GEX</h4>

      <input
        class="input-login"
        type="email"
        placeholder="Digite aqui seu email"
        @input="verificarEmail"
        @keyup="verificarEmail"
        v-model="email"
        name="email"
        autofocus
        required
        :disabled="emailEnviado || isLoading"
      />

      <button
        v-show="!emailEnviado"
        class="submit-login"
        type="submit"
        :disabled="!emailCorreto || isLoading"
      >
        <span
          v-if="isLoading"
          class="spinner"
        ></span>
        {{ isLoading ? "Carregando..." : "Enviar" }}
      </button>

      <p
        v-if="emailEnviado"
        class="msg-sucesso"
      >
        ✅ Um link de recuperação foi enviado para <strong>{{ email }}</strong
        >. Por favor, verifique sua caixa de entrada ou de spam.
      </p>
    </template>

    <!-- FLUXO 2: Com token → campos de nova senha -->
    <template v-else>
      <h3>Redefinir Senha</h3>
      <h4>Digite e confirme sua nova senha GEX</h4>

      <input
        class="input-login"
        type="password"
        placeholder="Nova senha"
        v-model="novaSenha"
        name="novaSenha"
        autofocus
        required
      />
      <input
        class="input-login"
        type="password"
        placeholder="Confirme sua nova senha"
        v-model="confirmarSenha"
        name="confirmarSenha"
        required
        :disabled="!verificarSenha()"
      />

      <p
        class="msg-erro"
        v-if="novaSenha && confirmarSenha && novaSenha !== confirmarSenha"
      >
        As senhas não são iguais
      </p>
      <p
        class="msg-erro"
        v-if="novaSenha && (novaSenha.length < 6 || novaSenha.length > 36)"
      >
        A senha deve ter entre 6 e 36 caracteres
      </p>
      <p
        class="msg-erro"
        v-if="novaSenha && novaSenha.includes(' ')"
      >
        A senha não pode conter espaços
      </p>
      <p
        class="msg-erro"
        v-if="novaSenha && !temCaracterEspecial(novaSenha)"
      >
        A senha deve conter pelo menos um caractere especial
      </p>

      <button
        class="submit-login"
        type="submit"
        :disabled="!senhaValida || isLoading"
      >
        <span
          v-if="isLoading"
          class="spinner"
        ></span>
        {{ isLoading ? "Salvando..." : "Redefinir Senha" }}
      </button>
    </template>
  </form>
</template>

<script>
import controleDeAcessoService from "@/service/controleDeAcessoService";
import router from "@/router";
import { useRoute } from "vue-router";

export default {
  data() {
    return {
      token: null,
      // Fluxo 1
      email: "",
      emailCorreto: false,
      emailEnviado: false,
      // Fluxo 2
      novaSenha: "",
      confirmarSenha: "",
      // Geral
      isLoading: false,
      caracteresEspeciais: /[!@#$%^&*(),.?":{}|<>;]/,
      route: useRoute(),
    };
  },

  computed: {
    senhaValida() {
      return (
        this.novaSenha.length >= 6 &&
        this.novaSenha.length <= 36 &&
        !this.novaSenha.includes(" ") &&
        this.temCaracterEspecial(this.novaSenha) &&
        this.novaSenha === this.confirmarSenha
      );
    },
  },

  watch: {
    "$route.query.token": {
      immediate: true,
      handler() {
        this.atualizarTokenDaUrl();
      },
    },
  },

  mounted() {
    this.atualizarTokenDaUrl();
  },

  methods: {
    atualizarTokenDaUrl() {
      const queryToken = this.$route?.query?.token;
      const rawToken =
        (Array.isArray(queryToken) ? queryToken[0] : queryToken) ||
        new URLSearchParams(window.location.search).get("token") ||
        null;

      if (!rawToken) {
        this.token = null;
        return;
      }

      const limpo = String(rawToken).trim();
      const matchUuid = limpo.match(
        /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
      );
      this.token = matchUuid ? matchUuid[0] : limpo;
    },

    voltar() {
      if (this.route.name !== "recuperar-senha-perfil") {
        router.push({ name: "autenticacao-gex" });
      } else {
        router.push({ name: "perfil" });
      }
    },

    verificarEmail() {
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailCorreto = regexEmail.test((this.email || "").trim());
    },

    temCaracterEspecial(senha) {
      return this.caracteresEspeciais.test(senha);
    },

    verificarSenha() {
      return (
        this.novaSenha.length >= 6 &&
        this.novaSenha.length <= 36 &&
        !this.novaSenha.includes(" ") &&
        this.temCaracterEspecial(this.novaSenha)
      );
    },

    async enviar() {
      if (this.isLoading) return;

      // FLUXO 2: tem token → redefinir senha
      if (this.token) {
        if (!this.senhaValida) return;

        try {
          this.isLoading = true;
          const response = await controleDeAcessoService.redefinirSenha({
            token: this.token,
            senha: this.novaSenha,
          });

          if (
            !response ||
            response.status === 200 ||
            response.status === 204 ||
            response === ""
          ) {
            alert("Senha redefinida com sucesso, faça login!");
            router.push({ name: "autenticacao-gex" });
          } else {
            alert(
              "Erro ao redefinir a senha. O link pode ter expirado, você será redirecionado para a tela anterior."
            );
            this.token = null;
            router.push({ name: "recuperar-senha" });
          }
        } catch (error) {
          const msgBackend =
            error?.response?.data?.message ||
            error?.response?.data?.details ||
            error?.data?.message ||
            "Erro ao redefinir a senha. O link pode ter expirado.";
          alert(msgBackend);
          this.token = null;
          router.push({ name: "recuperar-senha" });
        } finally {
          this.isLoading = false;
        }
        return;
      }

      // FLUXO 1: sem token → enviar email
      this.verificarEmail();
      if (!this.emailCorreto) {
        alert("Digite um email válido para continuar.");
        return;
      }

      try {
        this.isLoading = true;
        await controleDeAcessoService.recuperarSenha(this.email);
        this.emailEnviado = true;
      } catch (error) {
        if (error?.data?.message === "Aguarde para nova requisição" || error?.response?.data?.message === "Aguarde para nova requisição") {
          alert(
            "Um link já foi enviado. Aguarde 10 minutos para uma nova solicitação."
          );
          this.emailEnviado = true;
        } else {
          alert("Erro ao enviar o email. Tente novamente.");
        }
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: var(--branco);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px hsla(0, 0%, 0%, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

.form-entrar h3 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--roxo-medio);
  text-align: center;
}

.form-entrar > div:first-child a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  background: var(--roxo-primario);
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--branco);
  transition: all 0.3s ease;
}

.form-entrar > div:first-child a::before {
  content: "←";
  font-size: 0.9rem;
}

.form-entrar > div:first-child a:hover {
  background: var(--roxo-medio);
}
.form-entrar > div:first-child a:active {
  background: var(--roxo-primario);
}

h4 {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--preto);
  max-width: 280px;
  text-align: center;
}

.submit-login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--branco);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.msg-sucesso {
  font-size: 0.9rem;
  color: var(--verde);
  background: var(--verde-claro);
  border: 1px solid var(--verde-claro);
  border-radius: 8px;
  padding: 0.8rem 1rem;
  text-align: center;
}

.msg-erro {
  font-size: 0.82rem;
  color: var(--vermelho);
  margin: 0;
}
</style>
